import {useState} from "react";
import {Popup} from "antd-mobile";
import CalendarModalDate from "./calendarModalDate";

const CalendarModalParentDate = ({visible, onCancel, onData}) => {

    const [destroy, setDestroy] = useState(false)
    return (
        <Popup
            visible={visible}
            onMaskClick={() => {
                setDestroy(true)
            }}
            onClose={() => {
                setDestroy(true)
            }}
            position={"right"}
            bodyStyle={{width: "100%"}}
        >
            <CalendarModalDate onCancel={onCancel}
                               destroy={destroy}
                               onDestroy={() => {
                                   setDestroy(false)
                               }}
                               onCancelTemp={()=>setDestroy(true)}
                               onData={onData} />
        </Popup>
    )
}
export default CalendarModalParentDate
